import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeNavigate'
})
export class SafeNavigatePipe implements PipeTransform {

  transform(keys: any, args?: any): any {
    debugger;
    let val = args;
    let idx = 0;
    while (idx < keys.length) {
      if (val == null) {
        return;
      }
      val = val[keys[idx]];
      idx += 1;
    }

    return val;

  }

}



// WEBPACK FOOTER //
// /app/src/app/safe-navigate.pipe.ts